import { request } from "/src/utils/index.js";

export function Search(params) {
  return request.get("/sdbs/appointment/list", { params });
}

export function SearchCustomer(params) {
  return request.get("sdbs/customer/list/page", { params });
}

export function SearchEmployee(params) {
  return request.get("sdcom/employee/list/page", { params });
}

export function Add(params) {
  return request.post("tcm/prescription/ai", params);
}

export function Generate(params) {
  return request.post("sdbs/appointment/generateMR", params);
}

export function AddCustomer(params) {
  return request.post("sdbs/customer", params);
}

export function AddAppointment(params) {
  return request.post("sdbs/appointment", params);
}
export function GenerateRecord(params) {
  return request.post("tcm/medical/record", params);
}

export function Start(params) {
  return request.post("tcm/medical/record/perform", params);
}

export function Update(params) {
  return request.put("sdbs/appointment", params);
}


export function Delete(data) {
  return request.delete("sdbs/appointment", { data });
}
